import validate from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45route_45global from "/home/homeyou/shc/build/build-headless/101573/middleware/01.route.global.ts";
import _02_45redirects_45global from "/home/homeyou/shc/build/build-headless/101573/middleware/02.redirects.global.ts";
import _04_45mini_45cart_45global from "/home/homeyou/shc/build/build-headless/101573/middleware/04.miniCart.global.ts";
import _05_45wishlist_45counter_45global from "/home/homeyou/shc/build/build-headless/101573/middleware/05.wishlistCounter.global.ts";
export const globalMiddleware = [
  validate,
  _01_45route_45global,
  _02_45redirects_45global,
  _04_45mini_45cart_45global,
  _05_45wishlist_45counter_45global
]
export const namedMiddleware = {
  cart: () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-cart-layer/middleware/cart.ts"),
  "map-points": () => import("/home/homeyou/shc/build/build-headless/101573/layers/nuxt-bbk-store-locator-layer/middleware/map-points.ts"),
  "algolia-labels": () => import("/home/homeyou/shc/build/build-headless/101573/middleware/algoliaLabels.ts"),
  authorization: () => import("/home/homeyou/shc/build/build-headless/101573/middleware/authorization.ts"),
  login: () => import("/home/homeyou/shc/build/build-headless/101573/middleware/login.ts")
}